import React, { useEffect } from 'react';
import Card from '@mui/material/Card';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';
import { expiryDate, convertDate } from '../../Helpers/helpers';

// const expiryDate = (date, warrantee) => {
//   const warranteePeriod = parseFloat(warrantee) * 365;
//   const getWarranteeDate = new Date(date);
//   getWarranteeDate.setDate(getWarranteeDate.getDate() + warranteePeriod);

//   return getWarranteeDate.toDateString();
// };

function CustomerSerialNumbers({ serialCustomerId }) {
  // const [customerId, setCustomerId] = React.useState(serialCustomerId);
  const [serials, setSerials] = React.useState([]);
  const [forceUpdate, setForceUpdate] = React.useState(+1);
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications

  const CustomerId = serialCustomerId;

  // const location = useLocation();
  // const customerData = location.state;

  const serialsEndpoint = (mode) => {
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }

    let body = {};
    const request = new Request(`${APIROOT}/api/customers/${CustomerId}`, {
      method: 'post',
      headers,
      body: JSON.stringify(body),
    });

    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to get Serials from server`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          if (mode === 'get') {
            let data = parsed.data.value.serial_numbers.sort(
              (a, b) =>
                a.cabinet_type.toLowerCase() - b.cabinet_type.toLowerCase()
            );
            setSerials(data);
          } else {
            setForceUpdate((val) => val + 1);
          }
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : 'Connection Error',
          'error'
        );
      });
  };

  useEffect(() => {
    serialsEndpoint('get');
  }, [forceUpdate]);

  return (
    <Card style={{ margin: '15px 0', padding: 0 }}>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        style={{
          // background: '#84a1bc91',
          background: 'rgb(235, 237, 248)',
          height: 'auto',
          // borderRadius: 15,
          padding: '5px 10px 5px 20px',
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography variant='h5'>Serial Numbers</Typography>
        </Grid>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    background: 'rgb(76, 175, 80)',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                >
                  Cabinet Type
                </TableCell>
                <TableCell
                  style={{
                    background: 'rgb(76, 175, 80)',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Serial Number
                </TableCell>
                <TableCell
                  style={{
                    background: 'rgb(76, 175, 80)',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Install Date
                </TableCell>
                <TableCell
                  style={{
                    background: 'rgb(76, 175, 80)',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='right'
                >
                  Warrantee Expiry
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {serials
                .sort(
                  (a, b) =>
                    a.cabinet_type.toLowerCase() - b.cabinet_type.toLowerCase()
                )
                .map((row) => (
                  <TableRow
                    key={row.number}
                    sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                  >
                    <TableCell component='th' scope='row'>
                      {row.cabinet_type}
                    </TableCell>
                    <TableCell align='right'>{row.number}</TableCell>
                    <TableCell align='right'>
                      {convertDate(row.install_date, 0, 10)}
                    </TableCell>
                    <TableCell align='right'>
                      {expiryDate(row.install_date, row.warranty_period)}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Card>
  );
}

export default CustomerSerialNumbers;
